import store from "@frameworks/web/redux/store";
import { CLIENT_VAL_PASS, CLIENT_VAL_PASS_ERROR, CLIENT_VAL_PASS_HIDE_ERROR, CLIENT_VAL_PASS_START_LOADER, CLIENT_VAL_PASS_STOP_LOADER, } from "../interface/IClientValPassword";
class ClientValPassActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    ClientValPassword(data) {
        this.dispatch({
            type: CLIENT_VAL_PASS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: CLIENT_VAL_PASS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: CLIENT_VAL_PASS_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: CLIENT_VAL_PASS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: CLIENT_VAL_PASS_STOP_LOADER,
        });
    }
}
export default ClientValPassActions;
